// @flow
import type { Component } from 'react';
import Home from 'Home';
import Results from 'Results';
import Detail from 'Detail';
import BrowseAllMakes from 'BrowseAllMakes';

type StaticRoute = {|
  path: string,
  exact: boolean,
  component: Component<any, any>,
  routes: StaticRoute[]
|};

const staticRoutes: StaticRoute[] = [
  {
    path: '/used-cars',
    exact: true,
    component: Home,
    routes: []
  },
  {
    path: '/used-cars/all',
    exact: true,
    component: Results,
    routes: []
  },
  {
    path: '/used-cars/dealer/:id',
    exact: true,
    component: Results,
    routes: []
  },
  {
    path: '/used-cars/browse-all-makes',
    exact: true,
    component: BrowseAllMakes,
    routes: []
  },
  {
    path: '/used-cars/:make/:model/:name/:id',
    exact: true,
    component: Detail,
    routes: []
  },
  {
    path: '/used-cars/:make',
    exact: true,
    component: Results,
    routes: []
  },
  {
    path: '/used-cars/:make/:model',
    exact: true,
    component: Results,
    routes: []
  }
];
export default staticRoutes;



// WEBPACK FOOTER //
// ./src/App/client/routes/index.js